import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import ReportAbuseForm from '../../components/report-abuse-form';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

export const ReportMemberModal = ({ closeModal, userId, reportUser, t }) =>
  <Modal onClose={closeModal}>
    <ReportAbuseForm
      initialValues={{ _id: userId, reportType: '1' }}
      onSubmit={reportUser}
      onCancel={closeModal}
      title={t('report-member-modal.report-member')}
      message={t('report-member-modal.help-us-understand')}
    />
  </Modal>;

ReportMemberModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  reportUser: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  closeModal,
  reportUser: report => closeModal(report),
};

export default connect(undefined, mapDispatchToProps)(withTranslate(ReportMemberModal));



// WEBPACK FOOTER //
// ./app/containers/report-member-modal/report-member-modal.js